<div class="layout-topbar">
    <a class="layout-topbar-logo" routerLink="">
        <img style="height: 50px;" src="../../assets/layout/images/PSHealth_logo.png" alt="logo">
        <!-- <span>SAKAI</span> -->
    </a>

    <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
        <i class="pi pi-bars"></i>
    </button>
    <div style="width: 100%; padding: 20px; margin-bottom: 10px;">
        <span class="block mt-2 md:mt-0 p-input-icon-left">
            <!-- <i class="pi pi-search" style="margin-top: 0px"></i> -->
            <h2 style="text-align: center; margin-top: 20px;">Learning Management System</h2>
        </span>
    </div>
    <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button" (click)="layoutService.showProfileSidebar()">
        <i class="pi pi-ellipsis-v"></i>
    </button>
    
    <div #topbarmenu class="layout-topbar-menu" [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">
        <!-- <button class="p-link layout-topbar-button">
            <i class="pi pi-calendar"></i>
            <span>Calendar</span>
        </button>
        <button class="p-link layout-topbar-button">
            <i class="pi pi-user"></i>
            <span>Profile</span>
        </button>
        <button class="p-link layout-topbar-button" [routerLink]="'/documentation'">
            <i class="pi pi-cog"></i>
            <span>Settings</span>   
        </button> -->
        <!-- <button class="p-link layout-topbar-button">
            <i class="pi pi-key"  pTooltip="Chnage Password" ></i>
            <span>Change Password</span>
        </button> -->
        <button class="p-link layout-topbar-button" (click)="logout()">
            <i class="pi pi-power-off"></i>
            <span>Logout</span>
        </button>
    </div>
</div>